export default function totalChars(city: any, state: any, zipcode: any) {
  const totalChars = state.length + city.length + zipcode.length;
  return totalChars;
}
